// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"44cfd723","247":"fb399f77","317":"d7443c50","358":"48b904f5","521":"5aa18cd6","614":"d4b91493","678":"6bdbd685"}[chunkId] + ".chunk.js";
};